class LocalStorageKeys {
    static ORGANIZATION_ID_KEY = "ORGANIZATION_ID_KEY"
    static PROJECT_ID_KEY = "PROJECT_ID_KEY"
    static EDITED_POST_SKUUID = "editedPostSkuuid"
}

export default LocalStorageKeys;
